
  <div [@item] class="buttonContainer">
      <button mat-raised-button class="backButton button large" (click)="closeConvo()">Back</button>
      <button mat-raised-button class="backButton button small" (click)="closeConvo()">&larr;</button>
 
      <h2 *ngIf="participants" >
        <span *ngFor="let participant of participants | async; let first = first; let last = last">

            <span class="large" *ngIf='!last && !first'> , </span>
            <span class="large" *ngIf="last && !first"> and </span> 
            <span class="large" *ngIf="profile?.uid !== participant?.key" (click)="open(participant?.key, $event)"> {{participant?.firstname | titlecase}} {{participant?.lastname | firstLetter | titlecase}} </span>
            <span class="small titleAvatar" *ngIf="profile?.uid !== participant?.key" (click)="open(participant?.key, $event)"> {{participant?.firstname | firstLetter | titlecase}} {{participant?.lastname | firstLetter | titlecase}} </span>
            <span class="large" *ngIf="profile?.uid === participant?.key"> You </span> 
            <span class="small titleAvatar" *ngIf="profile?.uid === participant?.key">You</span>
  
      </span>
      </h2>
      <!-- All Correct SVG -->
    <div [ngClass]="{'correctFlex': meta?.resolved, 'incorrectFlex': !meta?.resolved}">
        <div 
          *ngIf="meta?.resolved"
          style="width: 10%; margin: 10px auto 10px auto">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        <span *ngIf="meta?.resolved" style="margin: 30px">Answered</span>
     </div>
      <div class="flex">
          <div *ngIf="confirmationButtons === 'show'"  [@confirmationTrigger]=confirmationButtons (@confirmationTrigger.done)=closeClaimConfirmationEnd($event)  class="flex" >
            <p  *ngIf="confirmationButtons === 'show'" class="large" >Are you sure?</p>&nbsp;
            <p *ngIf="confirmationButtons === 'show'" class="small" style="font-size: 12px" >You sure?</p>&nbsp;
            <button *ngIf="confirmationButtons === 'show'" class="yesButton headerButton basic large" (click)="claim()">Yes</button>
            <button *ngIf="confirmationButtons === 'show'" class="noButton headerButton basic large" (click)="closeClaimConfirmation()">No</button>
            <button *ngIf="confirmationButtons === 'show'" class="yesButton headerButton basic small" (click)="claim()">Y</button>
            <button *ngIf="confirmationButtons === 'show'" class="noButton headerButton basic small" (click)="closeClaimConfirmation()">N</button>
        </div>
        <button class="headerButton button" 
        [ngClass]="{'claimed': meta?.instructor, 'unclaimed': !meta?.instructor}"
        [@claimTrigger]=claimButton (@claimTrigger.done)="presentClaimConfirmationEnd($event)"(click)="claimButtonPress()">
          <div *ngIf="!meta?.instructor " class="smooth">Claim</div>
          <div *ngIf="meta?.instructor " class="smooth">Override Instructor</div>

        </button>
      </div>
      <mat-form-field [@item] *ngIf="autoRepliesTrigger !== 'void'" >
        <mat-label>Search Auto Replies</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
      </mat-form-field>
      

  </div><br>
<!-- context for lessonID and question ID -->
  <div
    class="context-ids preview-toggle"
    matTooltip="Which guide and question the inquiry is from. Click to preview."
    [ngClass]="{'preview-disabled': !hasQuestionPreviewContext()}"
    (click)="toggleQuestionPreview()">
    <span *ngIf="!!meta?.lessonID" >Lesson {{meta?.lessonID}}</span>
    <span>&nbsp;:&nbsp;</span>
    <span *ngIf="!!meta?.questionID" >Question {{meta?.questionID}}</span>
    <span *ngIf="hasQuestionPreviewContext()">&nbsp;&nbsp;{{questionPreviewExpanded ? 'Hide Preview' : 'Preview'}}</span>
  </div>
  <div *ngIf="questionPreviewExpanded" class="question-preview">
    <div class="question-preview-header">
      <span class="question-preview-label">Lesson {{questionPreviewLessonId}} : Question {{questionPreviewQuestionId}}</span>
    </div>
    <div class="question-preview-body">
      <div *ngIf="questionPreviewLoading">Loading question preview...</div>
      <div *ngIf="!questionPreviewLoading && !questionPreviewQuestion">Question data unavailable.</div>
      <div *ngIf="!questionPreviewLoading && !!questionPreviewQuestion">
        <h3 class="question-preview-title">
          {{questionPreviewQuestion.questionIDTitle || questionPreviewQuestion.questionID}}. {{questionPreviewQuestion.question}}
        </h3>
        <p *ngIf="questionPreviewQuestion.subQuestion" class="question-preview-sub">
          {{questionPreviewQuestion.subQuestion}}
        </p>

        <div *ngIf="questionPreviewQuestion.verses?.length" class="question-preview-section">
          <div class="question-preview-section-title">Bible Verses</div>
          <div *ngFor="let verse of questionPreviewQuestion.verses; let i = index" class="question-preview-item">
            <div class="question-preview-item-ref">
              {{verse?.ref || ('Verse ' + (i + 1))}}
            </div>
            <div class="question-preview-item-body">
              {{verse?.body}}
            </div>
          </div>
        </div>

        <div *ngIf="questionPreviewSupplements?.length" class="question-preview-section">
          <div class="question-preview-section-title">Supplements</div>
          <div class="question-preview-hint">Click a supplement title to expand/collapse.</div>
          <div *ngFor="let supplement of questionPreviewSupplements; let i = index" class="question-preview-item">
            <button mat-stroked-button class="question-preview-toggle" (click)="togglePreviewSupplement(i)">
              {{supplement?.title || ('Supplement ' + (i + 1))}}
            </button>
            <div *ngIf="expandedPreviewSupplementIndex === i" class="question-preview-item-body">
              {{supplement?.body}}
            </div>
          </div>
        </div>

        <div *ngIf="questionPreviewQuestion.body" class="question-preview-section">
          <div class="question-preview-section-title">Body</div>
          <div class="question-preview-item-body" [innerHtml]="questionPreviewQuestion.body | newline"></div>
        </div>
      </div>
    </div>
    <div class="question-preview-actions">
      <button mat-stroked-button (click)="previewPreviousQuestion()" [disabled]="!canNavigatePreviewPrevious()">Prev</button>
      <button mat-stroked-button (click)="previewNextQuestion()" [disabled]="!canNavigatePreviewNext()">Next</button>
      <button mat-stroked-button (click)="toggleQuestionPreview()">Collapse</button>
    </div>
  </div>
  <div class="horizontalLine"></div>
  <div id="eMessageContainer" *ngIf="conversation" class="expandedMessage">
        
      <div   *ngFor="let message of conversation | async; let last = last" style="width: 100%">
        <div 
          *ngIf="autoRepliesTrigger === 'void'"
          [@item]
          class="messageContainer" 
          [ngClass]="{
            'left': message?.creator !== profile?.uid && !message?.system,
            'right': message?.creator === profile?.uid && !message?.system,
            'center': message?.system}">
            <div
              *ngIf="profile?.uid !== message?.creator && !message?.system"
              class="noAvatar "
              (click)="open(message?.creator, $event)">
                {{message?.profileName | titlecase}}
            </div>

            <div 
              class="message regularText" 
              [ngClass]="{'leftStyle': message?.creator !== profile?.uid && !message?.system,
               'rightStyle': message?.creator === profile?.uid && !message?.system,
               'centerStyle': message?.system}" 
               [innerHtml]="message?.message | newline"
               >  
               </div>
              <!-- {{message?.message}}</div> -->
        </div > 
        <div *ngIf="last" class="expandedMessage" style="height: auto" [@auto]=autoRepliesTrigger>
            <div style="width: 1px; height: 1px;"></div>
            <span style="font-size: 1.3em">Auto Replies</span>
            <div 

              [@item]
            *ngFor="let reply of filteredAutoReplies"
              (click)="chooseAutoReply(reply.body)"
              class="message regularText rightStyle button">  
              {{filter === "" ? (reply?.body | limit : 60) : reply?.body }}</div>
              <div class="noAvatar button" (click)="toggleAutoReplyTrigger()"><span>Close</span></div>
              <span class="button" [@rotate]=autoRepliesTrigger style="color: #4A829B" (click)="toggleAutoReplyTrigger()">&#8682;</span>
        </div> 
        <div *ngIf="last"  class="horizontalLine"></div>
        <div *ngIf="last" class="messageContainer center">{{message.date | relativeDate}}</div> 
        <div class="center" style="margin: 20px;">
          <button *ngIf="last" mat-raised-button (click)="toggleAnswered()">{{meta?.resolved ? 'Not Answered Yet?' : 'Question Answered?'}}</button>
        </div>
      </div>

  

      <div id=messageBottom style="width: 1px; height: 1px;"></div>


      
  </div>
  <div class="flexTextAreaAndButton">
      <form style="width: 100%;" (ngSubmit)="send()"  >
          <textarea style="border-color: lightgrey; border-style: solid; border-width: 2px;"
          name="reply" class="replyBox"
          placeholder="Type Something..." [(ngModel)]="messageToSend">
            </textarea><br>
      </form>
    <div class="buttonContainer">
      <button mat-raised-button *ngIf="authLevel && messageToSend == '' && autoReplies?.length > 0" class="submitButton button" (click)="toggleAutoReplyTrigger()"><span>{{autoRepliesTrigger === 'void' ? 'Automated Replies' : 'Close'}}</span></button>
      <button mat-raised-button *ngIf="authLevel && messageToSend !== ''" class="noAvatar button" (click)="createNewAutoReply()"><span>Save as Auto Reply and Send</span></button>
      <div class="right">
        <button *ngIf="authLevel" mat-raised-button class="submitButton" (click)="sendAndNotify()">Notify and Send</button>
        <button mat-raised-button class="submitButton" (click)="send()">Send</button>
        
      </div>
    </div>
</div>
  
  
  
  
  <!-- /* [ngClass]="{'regNoAv': meta?.isVolunteer !== message?.creator, 'volNoAv': meta?.isVolunteer === message?.creator}"*/ -->